import {
  CompanyFiscalCal,
  DateGroupingKey,
  getGroupingValue
} from '@blisspointmedia/bpm-types/dist/FiscalCalendar';
import { LiftFromTvRow } from './lift-from-tv-chart-constants';

export const getDataByDateGrouping = (
  data: LiftFromTvRow[],
  dateGrouping: DateGroupingKey,
  fiscalCal: CompanyFiscalCal
) => {
  const totalsByDate: Record<string, { volumeWithTv: number; volumeWithoutTv: number }> = {};
  for (const { date, volumeWithTv, volumeWithoutTv } of data) {
    const dateToUse = getGroupingValue(date, dateGrouping, fiscalCal);
    const totals = totalsByDate[dateToUse] ?? { volumeWithTv: 0, volumeWithoutTv: 0 };
    totalsByDate[dateToUse] = {
      volumeWithTv: totals.volumeWithTv + volumeWithTv,
      volumeWithoutTv: totals.volumeWithoutTv + volumeWithoutTv
    };
  }

  return Object.entries(totalsByDate)
    .map(([date, totals]) => ({ date, ...totals }))
    .sort((a, b) => a.date.localeCompare(b.date));
};
